import React from 'react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { mqUser, mqMin } from 'utils/responsive';
import LogoImg from 'ui/images/logo.svg';

const Header = styled.header`
    width: 100%;
    background-color: var(--pale-blue);
    font-weight: 700;
`;

const HeaderContent = styled.div`
    display: flex;
    align-items: flex-end;
    width: 87.67441860465116%;
    padding: 10px 0;
    margin: 0 auto 0 auto;

    ${mqMin('SP')} {
        align-items: center;
    }

    ${mqMin('NARROW')} {
        width: 92.01388888888889%;
    }
`;

const Title = styled.h1`
    margin: auto 0;
    img {
        cursor: pointer;
        height: 50px;
    }

    ${mqUser('SP')} {
        font-size: 1rem;

        img {
            width: 100%;
        }
    }
`;

const Nav = styled.nav`
    display: flex;
    margin-left: auto;
    justify-content: flex-end;
    flex-wrap: wrap-reverse;
    align-items: center;
    margin: auto 0 auto auto;
    gap: 10px;

    ${mqMin('SP')} {
        gap: 15px;
    }

    ${mqMin('NARROW')} {
        width: calc(100% - 152px);
    }
`;

const NavItem = styled.a`
    display: block;
    color: #fff;
    font-size: 1rem;
    text-align: center;
    cursor: pointer;

    &:visited {
        color: var(--white);
    }
`;

const LinkButton = styled(NavItem)`
    border: solid 1px #fff;
    border-radius: 7px;
    line-height: 1em;
    padding: 7px 19px;
    margin-right: 10px;
    transition: all 0.3s;
    font-size: 0.875rem;

    &:hover {
        background-color: var(--blue);
    }
`;

export const HeaderNarrow = () => {
    const navigate = useNavigate();
    const goToAgentTop = () => {
        navigate('/agent/login/');
    };
    const goToTop = () => {
        navigate('/company/login/');
    };
    return (
        <Header>
            <HeaderContent>
                <Title onClick={goToTop}>
                    <img src={LogoImg} alt="MAny" />
                </Title>
                <Nav>
                    <LinkButton onClick={goToTop}>売手企業ページ</LinkButton>
                    <LinkButton onClick={goToAgentTop}>仲介会社ページ</LinkButton>
                </Nav>
            </HeaderContent>
        </Header>
    );
};
